module.exports = __webpack_public_path__ + "media/images/vamp_template-9b0b1480d929260e32cc002d324ee9e0.jpg";